import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press9',
  templateUrl: './notice-press9.component.html',
  styleUrls: ['./notice-press9.component.scss']
})
export class NoticePress9Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
